import { slugToName } from '@virginexperiencedays/search/utils/category';

import { LinkWrap } from '../../../../navigation/LinkWrap';

type CategoryLinkProp = {
  categoryHierarchy: { lvl0: string; lvl1: string; lvl2: string };
  keySuffix: number;
};

export const CategoryLink = ({ categoryHierarchy, keySuffix }: CategoryLinkProp) => {
  const { lvl0, lvl1, lvl2 } = categoryHierarchy;
  const linkLvl = lvl2 ?? lvl1 ?? lvl0;
  const slug = linkLvl?.split('/').pop();
  const categoryName = slugToName(slug);
  const categoryLinkKey = `category-${keySuffix}`;

  if (!slug?.length) return null;

  return (
    <LinkWrap
      className="bg-background-primary mb-2 w-fit rounded-sm px-1 py-0.5 text-xs font-semibold uppercase leading-none tracking-tight text-white"
      href={`${process.env.NEXT_PUBLIC_HOME_LINK}/${slug}`}
      key={categoryLinkKey}
      target="_blank"
      rel="noreferrer"
    >
      {categoryName}
    </LinkWrap>
  );
};
